WYATT.registerComponent(
  "product-zoom-image",
  class ImageZoom extends HTMLElement {
    connectedCallback() {
      if (window.innerWidth >= WYATT.config.breakPoints.medium) {
        this.bindEvents();
      }
    }

    bindEvents() {
      const zoomableImages = document.querySelectorAll("[data-zoom-image]");

      zoomableImages.forEach((image) => {
        image.addEventListener(
          "mouseenter",
          this.handleMouseEnter.bind(this),
          false
        );
        image.addEventListener(
          "mousemove",
          this.handleMouseMove.bind(this),
          false
        );
        image.addEventListener(
          "mouseleave",
          this.handleMouseLeave.bind(this),
          false
        );
      });
    }

    handleMouseEnter(e) {
      const image = e.target.dataset.zoomImage;
      this.style.backgroundImage = `url(${image})`;
      this.style.display = "block";
    }

    handleMouseMove(e) {
      const dimensions = e.target.getBoundingClientRect();
      const x = e.clientX - dimensions.left;
      const y = e.clientY - dimensions.top;
      const xPercent = Math.round(100 / (dimensions.width / x));
      const yPercent = Math.round(100 / (dimensions.height / y));

      this.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
    }

    handleMouseLeave(e) {
      this.style.display = "none";
      this.style.backgroundImage = "";
    }
  }
);
